module.exports = __webpack_public_path__ + "static/media/healthy.90963097.jpg";